import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import { Reveal } from './Reveal';
import { GoldBow } from './GoldBow';
import { Button } from './Button';
import { Tilt3D } from './Tilt3D';
import { IconClose } from './icons';
import { scrollToModels } from '../utils/scroll';
const TYPICAL = ['exp.typical.1', 'exp.typical.2', 'exp.typical.3', 'exp.typical.4', 'exp.typical.5'];
const QUEEN = ['exp.queen.1', 'exp.queen.2', 'exp.queen.3', 'exp.queen.4', 'exp.queen.5'];
export function QueenExperience() {
  const {
    t
  } = useLanguage();
  return <section className="w-full bg-offwhite" data-id="element-372" data-mp="3l9b0874d8v3h">
      <div className="mx-auto w-full max-w-7xl px-4 py-16 sm:px-6 md:py-24" data-id="element-373" data-mp="2xnwneyow7qe">
        <Reveal className="max-w-2xl" data-id="element-374" data-mp="3v171fr1r11bx">
          <p className="font-display text-[11px] font-bold uppercase tracking-[0.24em] text-camelink" data-id="element-375" data-mp="3v2i1bfs2poxr">
            {t('exp.eyebrow')}
          </p>
          <div aria-hidden="true" className="mt-3 h-[3px] w-12 bg-kred" data-id="element-376" data-mp="ct9803pnekct" />
          <h2 className="mt-5 font-display text-3xl font-extrabold uppercase leading-[1.02] tracking-[-0.02em] text-ink sm:text-5xl" data-id="element-377" data-mp="7ybwmq4wbywr">
            {t('exp.title')}
          </h2>
        </Reveal>

        <div className="mt-10 grid grid-cols-1 gap-6 lg:grid-cols-2 lg:gap-8" data-id="element-378" data-mp="12bfniadgg238">
          <Reveal data-id="element-379" data-mp="179h5erz59vd4">
            <Tilt3D className="h-full" max={4} data-id="element-380" data-mp="178yzt4qle4sj">
              <div className="h-full border border-ink/10 bg-white/60 p-6 sm:p-8" data-id="element-381" data-mp="1bcdi62206x95">
              <h3 className="font-display text-sm font-extrabold uppercase tracking-[0.18em] text-muted" data-id="element-382" data-mp="1gayhlz9flcwj">
                {t('exp.typicalTitle')}
              </h3>
              <ul className="mt-6 space-y-4" data-id="element-383" data-mp="1l873a9tsfz2j">
                {TYPICAL.map(key => <li key={key} className="flex items-start gap-3 text-base text-muted" data-id="element-384" data-mp="1q19zkppy9mmf">
                    <IconClose className="mt-1 h-4 w-4 shrink-0 text-muted/60" data-id="element-385" data-mp="1uyjlhve4rg5i" />
                    <span data-id="element-386" data-mp="1z27umiieujsv">{t(key)}</span>
                  </li>)}
                </ul>
              </div>
            </Tilt3D>
          </Reveal>

          <Reveal delay={0.1} data-id="element-387" data-mp="23y6lccr7odwg">
            <Tilt3D className="h-full" max={4} lift={10} data-id="element-388" data-mp="3xrvw2bmy1h2">
              <div className="relative h-full border border-ink/10 border-t-2 border-t-camel bg-white p-6 shadow-[0_20px_50px_-32px_rgba(5,20,31,0.45)] sm:p-8" data-id="element-389" data-mp="3w70yblesgio">
              {/* Red as a point color: the badge only. Never a button fill. */}
              <span className="absolute -top-3 left-6 bg-kred px-3 py-1 font-display text-[10px] font-extrabold uppercase tracking-[0.2em] text-white" data-id="element-390" data-mp="8x4kosm2hima">
                {t('exp.badge')}
              </span>
              <h3 className="mt-3 font-display text-sm font-extrabold uppercase tracking-[0.18em] text-ink" data-id="element-391" data-mp="inzb896cj4dj">
                {t('exp.queenTitle')}
              </h3>
              <ul className="mt-6 space-y-4" data-id="element-392" data-mp="rnunkhbn15f5">
                {QUEEN.map(key => <li key={key} className="flex items-start gap-3 text-base font-medium text-ink" data-id="element-393" data-mp="rm1gj0x44j6m">
                    {/* The gold bow as the bullet marker. */}
                    <GoldBow className="mt-1 h-4 w-5 shrink-0" color="#B08355" strokeWidth={1.6} data-id="element-394" data-mp="2tgisqw7ue2xk" />
                    <span data-id="element-395" data-mp="18yhr02tbtbpy">{t(key)}</span>
                  </li>)}
              </ul>
                {/* Next step in the story, not the form: they have just read WHY the
                    Queens are different, so the natural move is to look at cars. */}
                <Button type="button" onClick={scrollToModels} block className="mt-8" data-id="element-396" data-mp="145ontjdiabfz">
                  {t('exp.cta')}
                </Button>
              </div>
            </Tilt3D>
          </Reveal>
        </div>
      </div>
    </section>;
}